import { sleep } from '../../util';
const isRetriable = err => {
  const status = err.response?.status;
  switch (status) {
    case 500:
    case 502:
    case 503:
    case 504:
    case 507:
    case 509:
      return true;
    case 406:
    case 415:
      return err.response?.data?.errorCode === 1022;
    default:
      return false;
  }
};
export const createServerErrorRetryHandler = axios => async err => {
  if (!isRetriable(err)) {
    return Promise.reject(err);
  }
  const attempts = (err.config.serverErrorAttemptCount ?? 0) + 1;
  // Default is defined in Axios.ts, we can safely assume it's defined.
  const attemptsLimit = err.config.serverErrorAttemptLimit;
  if (attempts >= attemptsLimit) {
    return Promise.reject(err);
  }
  err.config.serverErrorAttemptCount = attempts;

  // Default is defined in Axios.ts, we can safely assume it's defined.
  const timeoutTime = err.config.serverErrorTimeout(err.config);
  if (timeoutTime > 0) {
    await sleep(timeoutTime);
  }

  // Disable the throttle for the retry request otherwise it won't actually send.
  err.config.disableNovaServiceThrottle = true;
  return axios.request(err.config);
};
//# sourceMappingURL=error-retry-handler.js.map